// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bookingTitle":"BookingSectionTitle_bookingTitle-1gyHP","link":"BookingSectionTitle_link-2g5R0"};